import {
    ChangeRecordValue,
    RecorderData, ScrollRecordValue
} from "../../Shared/Shared";
import {PlayerBase} from "./PlayerBase";
import {MousePlayer} from "./MousePlayer";
import 'es6-promise';

export class ScrollPlayer extends PlayerBase{
    constructor(private lastScrollY,private lastScrollX){
        super();
    }

    public async Execute(currentTime: number, record: RecorderData<ScrollRecordValue>) {
        return new Promise<number>(async (resolve)=>{

           let difference:number=record.time-currentTime;
            if(difference>0) {
                await this.Delay(difference);
                difference=200;
            }
            console.log('scrolling to'+record.value.top);
            if(this.lastScrollY!=record.value.top) {
                let topDifference=record.value.top-this.lastScrollY;
                jQuery('html').velocity('scroll', {duration: difference, offset: record.value.top,complete:()=>{
                    resolve(record.time)
                }});
                console.log(MousePlayer.MousePositionY+topDifference);
                MousePlayer.$mousePointer.velocity({top:MousePlayer.MousePositionY+topDifference},difference);
                this.lastScrollY=record.value.top;
                MousePlayer.MousePositionY=MousePlayer.MousePositionY+topDifference;
            }
            if(this.lastScrollX!=record.value.left) {
                let leftDifference=record.value.left-this.lastScrollX;
                jQuery('html').velocity('scroll', {axis:'x', duration: difference, offset: record.value.left,complete:()=>{
                    resolve(record.time)
                }});
                console.log(MousePlayer.MousePositionX+leftDifference);
                MousePlayer.$mousePointer.velocity({top:MousePlayer.MousePositionX+leftDifference},difference);
                this.lastScrollY=record.value.top;
                MousePlayer.MousePositionY=MousePlayer.MousePositionX+leftDifference;
            }
        });
    }



}


// WEBPACK FOOTER //
// ./Player/PlayerElements/ScrollPlayer.ts